import React, { FC } from "react";
import { Box, Button, VStack } from "@chakra-ui/react";
import moment from "moment";
import { LeadStatusTag } from "components";
import { DATE_CALENDAR_FORMAT_WITH_YEAR } from "constants/date";
import { GRS_VISIBLE_FOCUS_RING } from "constants/grs-pending-leads";
import { LeadStageEnum } from "enums/lead-stage.enum";
import { TLeadStatusBasic } from "types/lead-status.type";
import { formatDate } from "utils/date.utils";

const TO_BE_ACCEPTED_PLACEHOLDER_STATUS: TLeadStatusBasic = {
  id: 0,
  stageId: LeadStageEnum.UNREAD,
  name: "To be accepted",
};

interface IGrsPendingLeadDateCellProps {
  createdAt: string;
}

export const GrsPendingLeadDateCell: FC<IGrsPendingLeadDateCellProps> = ({
  createdAt,
}) => {
  return (
    <VStack spacing={0} alignItems={"left"} py={2}>
      <Box fontSize={"md"} fontWeight={"bold"}>
        {moment(createdAt).fromNow()}
      </Box>
      <Box fontSize={"sm"} color={"leadpro.400"}>
        {formatDate(createdAt, DATE_CALENDAR_FORMAT_WITH_YEAR)}
      </Box>
    </VStack>
  );
};

interface IGrsPendingLeadStatusCellProps {
  leadName: string;
  onAction: () => void;
}

export const GrsPendingLeadStatusCell: FC<IGrsPendingLeadStatusCellProps> = ({
  leadName,
  onAction,
}) => {
  return (
    <VStack spacing={2} alignItems={"flex-start"} width={"100%"} py={2}>
      <LeadStatusTag status={TO_BE_ACCEPTED_PLACEHOLDER_STATUS} />
      <Button
        size={"sm"}
        width={"100%"}
        bg={"cyan.800"}
        color={"white"}
        _hover={{ bg: "cyan.900" }}
        _active={{ bg: "cyan.900" }}
        _focusVisible={GRS_VISIBLE_FOCUS_RING}
        onClick={onAction}
        aria-label={`Click here to review GRS lead ${leadName}`}
      >
        Click here
      </Button>
    </VStack>
  );
};

interface IGrsPendingLeadPersonCellProps {
  leadName: string;
}

export const GrsPendingLeadPersonCell: FC<IGrsPendingLeadPersonCellProps> = ({
  leadName,
}) => {
  return (
    <Box fontSize={"md"} fontWeight={"bold"}>
      <Box as={"span"} color={"cyan.800"} mr={1}>
        GRS
      </Box>
      <Box as={"span"} color={"leadpro.700"}>
        {leadName}
      </Box>
    </Box>
  );
};
